import React from 'react'

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import './style.scss';
import { __, sprintf } from 'StylistParent/i18n';
import Dashicon from 'Components/dashicon';
import IconButton from 'Components/icon-button';

class SidebarHeader extends React.Component {
	onSetPanel = () => {

	}

	onSidebarTabChange = ( newId ) => {
		this.props.onSidebarTabChange( newId )
	}

	render() {
		const { sidebarTab } = this.props
		const closeSidebar = () => onToggleSidebar( undefined, false );

		return (
			<div className="components-panel__header edit-post-sidebar__panel-tabs">
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'styling' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'styling' ? 'is-active' : '' }` }
					aria-label={ __( 'Styling settings' ) }
				>
					{ __( "Styling" ) }
				</button>
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'code' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'code' ? 'is-active' : '' }` }
					aria-label={ __( 'CSS code' ) }
				>
					{ __( "Code" ) }
				</button>
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'pro' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'pro' ? 'is-active' : '' }` }
					aria-label={ __( 'Premium version' ) }
				>
					{ __( "Pro" ) }
				</button>
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'promo' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'promo' ? 'is-active' : '' }` }
					aria-label={ __( 'Promo' ) }
				>
					🐰
				</button>
			</div>
		)
	}
}

export default SidebarHeader;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/sidebar-header/index.js